import React from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useDispatch} from 'react-redux';
import {serviceOptions} from '../../../constants';
import {addRegisterAdvertisement} from '../../../../../../store/redux/advertisementRegisteration';

interface IServiceBottomsheet {
  openServiceBottomsheet: boolean;
  setOpenServiceBottomsheet: React.Dispatch<React.SetStateAction<boolean>>;
}

function ServiceBottomsheet({
  openServiceBottomsheet,
  setOpenServiceBottomsheet,
}: IServiceBottomsheet) {
  const dispatch = useDispatch();

  const handleItems = (value: string) => {
    setOpenServiceBottomsheet(false);
    dispatch(addRegisterAdvertisement({serviceBottomSheetData: value}));
  };

  return (
    <BottomSheet
      onDismiss={() => setOpenServiceBottomsheet(false)}
      open={openServiceBottomsheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col px-3 gap-4 pb-[35px] pt-[15px]">
        {serviceOptions?.map(item => {
          return (
            <div key={item.id} className="flex flex-col justify-center w-full">
              <span onClick={() => handleItems(item.value)}>{item.title}</span>
            </div>
          );
        })}
      </div>
    </BottomSheet>
  );
}

export default React.memo(ServiceBottomsheet);
